import { StanButton } from '@/components';
import { BasicInfoSection } from './BasicInfoSection';
import { SocialLinksSection } from './SocialLinksSection';
import { useProfileForm } from '../hooks/useProfileForm';
import { FormProvider } from 'react-hook-form';

interface ProfileFormProps {
    hideBasicInfo?: boolean;
}

export function ProfileForm({ hideBasicInfo = false }: ProfileFormProps) {
    const { form, onSubmit, isSubmitting } = useProfileForm();

    return (
        <FormProvider {...form}>
            <form onSubmit={onSubmit}>
                <div className='space-y-4 md:space-y-6'>
                    {!hideBasicInfo && <BasicInfoSection disabled={isSubmitting} />}

                    <SocialLinksSection disabled={isSubmitting} />

                    <div className='flex justify-end'>
                        <StanButton
                            name='save-profile'
                            type='submit'
                            color='primary'
                            loading={isSubmitting}
                            disabled={isSubmitting}
                        >
                            Save
                        </StanButton>
                    </div>
                </div>
            </form>
        </FormProvider>
    );
}
